import { render, staticRenderFns } from "./terminos-condiciones.vue?vue&type=template&id=bdc5cd50"
import script from "./terminos-condiciones.vue?vue&type=script&lang=js"
export * from "./terminos-condiciones.vue?vue&type=script&lang=js"
import style0 from "./terminos-condiciones.vue?vue&type=style&index=0&id=bdc5cd50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports